import { useApi } from '@omnipresentgroup/api';
import { type IsoDate, notifyError } from '@omnipresentgroup/design-system';
import { useCallback, useRef } from 'react';
import type { WretchResponse } from 'wretch/types';

import { API_BASE, API_PATH } from '../constants';

const ERROR_TITLE = 'Error';
const ERROR_MESSAGE =
  'Something went wrong while downloading the invoices report';
const FILE_NAME = 'contractor-invoices.csv';

export const useGetContractorInvoicesReport = ({
  startDate,
  endDate,
}: {
  startDate?: IsoDate;
  endDate?: IsoDate;
}) => {
  const { GET } = useApi();

  const downloadLink = useRef<HTMLAnchorElement>(null);

  const downloadInvoices = useCallback(async () => {
    return GET(
      `${API_BASE}/${API_PATH}/report`,
      {},
      {
        ...(startDate ? { start_date: startDate } : {}),
        ...(endDate ? { end_date: endDate } : {}),
      },
    ).then(async (response) => {
      if (!downloadLink || !downloadLink.current) {
        notifyError({
          title: ERROR_TITLE,
          description: ERROR_MESSAGE,
        });
        return;
      }

      const csvData: string = encodeURIComponent(
        await (response as WretchResponse).text(),
      );
      downloadLink.current.setAttribute(
        'href',
        `data:text/csv;charset=utf-8,${csvData}`,
      );
      downloadLink.current.setAttribute('download', FILE_NAME);
      downloadLink.current.click();
    });
  }, [GET, endDate, startDate]);

  return { downloadInvoices, downloadLink };
};
